const THEME_VALUES = {
  "colors.admin.bg-F2F3F8": "#f2f3f8",
  "colors.admin.border-E2E5EC": "#e2e5ec",
  "colors.admin.coreGray01": "#313135",
  "colors.admin.coreGray02": "#54555b",
  "colors.admin.coreGray03": "#8E8F9D",
  "colors.admin.coreGray04": "#b7b9c2",
  "colors.admin.coreGray05": "#e0e3e5",
  "colors.admin.coreGray06": "#eff1f2",
  "colors.admin.coreGray07": "#F7F8FA",
  "colors.admin.coreGrayBlack": "#1d1d1f",
  "colors.admin.coreGrayWhite": "#fff",
  "colors.admin.corePrimary01": "#181935",
  "colors.admin.corePrimary02": "#1E244D",
  "colors.admin.corePrimary03": "#37439C",
  "colors.admin.corePrimary04": "#4A5DEF",
  "colors.admin.corePrimary05": "#5670E6",
  "colors.admin.corePrimary07": "#D0DCFF",
  "colors.admin.corePrimary08": "#EBEFFD",
  "colors.admin.corePrimary09": "#F2F3F8",
  "colors.admin.coreProductBorder": "#E0E3E5",
  "colors.admin.coreProductDisableContainer": "#F7F8FA",
  "colors.admin.coreProductDisableContent": "#b7b9c2",
  "colors.admin.coreProductDivider": "#EFF1F2",
  "colors.admin.coreProductError01": "#fc655c",
  "colors.admin.coreProductSuccess01": "#426aff",
  "colors.admin.divider-EFF0F6": "#eff0f6",
  "colors.admin.primary-5767DD": "#5767dd",
  "colors.admin.sub-323232": "#323232",
  "colors.admin.sub-6C7293": "#6c7293",
  "colors.admin.sub-A7ABC3": "#a7abc3",
  "colors.admin.sub-D5D9F7": "#d5d9f7",
  "colors.admin.sub-F7F8FA": "#f7f8fa",
  "colors.admin.sub-FD397A": "#fd397a",
  "colors.admin.sub-FFFFFF": "#ffffff",
  "colors.apps.brandGray100": "#54555b",
  "colors.apps.brandGray200": "#64646f",
  "colors.apps.brandGray300": "#7a7b88",
  "colors.apps.brandGray50": "#313135",
  "colors.apps.brandGray600": "#b7b9c2",
  "colors.apps.brandGray700": "#cccfd5",
  "colors.apps.brandGray800": "#e0e3e5",
  "colors.apps.brandGray900": "#eeeff1",
  "colors.apps.brandGray950": "#f6f6f7",
  "colors.apps.brandGrayBlack": "#161617",
  "colors.apps.brandGrayWhite": "#ffffff",
  "colors.apps.brandPrimary300": "#c01037",
  "colors.apps.brandPrimary400": "#e31b42",
  "colors.apps.brandPrimary500": "#f63753",
  "colors.apps.brandPrimary600": "#fd6f80",
  "colors.apps.coreGray01": "#313135",
  "colors.apps.coreGray02": "#7a7b88",
  "colors.apps.coreGray03": "#8e8f9d",
  "colors.apps.coreGray04": "#b7b9c2",
  "colors.apps.coreGray05": "#cccfd5",
  "colors.apps.coreGray06": "#e0e3e5",
  "colors.apps.coreGray07": "#f6f6f7",
  "colors.apps.coreGrayBlack": "#161617",
  "colors.apps.coreGrayWhite": "#ffffff",
  "colors.apps.corePrimary01": "#e31b42",
  "colors.apps.corePrimary02": "#a11034",
  "colors.apps.corePrimary03": "#ffccd2",
  "colors.apps.corePrimary04": "#ffe4e5",
  "colors.apps.corePrimary05": "#fff1f2",
  "colors.apps.coreProductBorder": "#cccfd5",
  "colors.apps.coreProductDisableContainer": "#f6f6f7",
  "colors.apps.coreProductDisableContent": "#b7b9c2",
  "colors.apps.coreProductDivider": "#e0e3e5",
  "colors.apps.coreProductError01": "#fc655c",
  "colors.apps.coreProductPlaceholder": "#b7b9c2",
  "colors.apps.coreProductSuccess01": "#426aff",
  "colors.apps.semanticBlue800": "#1d3cb0",
  "fontFamily.NotoSans": "-apple-system, BlinkMacSystemFont, Apple SD Gothic Neo, Noto Sans KR, Arial, sans-serif",
  "fontFamily.dmSans": "-apple-system, BlinkMacSystemFont, Apple SD Gothic Neo, Noto Sans KR, Arial, sans-serif",
  "fontFamily.pretendard": "Pretendard, sans-serif",
  "screens.2xl": "1400px",
  "screens.lg": "992px",
  "screens.md": "768px",
  "screens.sm": "480px",
  "screens.xl": "1200px",
  "variables.admin.header-height": "60px",
  "variables.admin.min-width": "1200px",
  "variables.admin.navi-width": "272px",
  "variables.apps.fixed-bottom-height": "68px",
  "variables.apps.gutter": "20px",
  "variables.apps.max-width": "1480px",
  "variables.apps.min-width": "375px",
  "variables.apps.mobile-header-height": "60px",
  "variables.apps.mobile-header-sub-height": "0px",
  "variables.apps.mobile-tabbar-height": "60px",
  "variables.apps.pc-header-height": "100px",
  "variables.apps.pc-header-sub-height": "0px"
} as const;

type ThemePath = keyof typeof THEME_VALUES;

export default function theme(strings: TemplateStringsArray): string {
  const path = strings[0] as ThemePath;
  const value = THEME_VALUES[path];

  if (value === undefined) {
    throw new Error('Unknown theme path: ' + path);
  }

  return value;
}
